import React, { Component } from 'react';
import { HashRouter as Router, Route, Switch, Redirect } from 'react-router-dom';
import './App.css';
import * as SecureLS from 'secure-ls';

const loading = () => <div className="animated fadeIn pt-3 text-center">Loading...</div>;
const Login = React.lazy(() => import('./pages/login'));
const Accueil = React.lazy(() => import('./pages/accueil'));
const TemplateMain = React.lazy(() => import('./template/main'));
const ls = new SecureLS({
  encodingType: 'aes',
  encryptionSecret: 'gespress'
});
const authInfos = ls.get("gespressAuthInfos");

function SecuredRoute(props) {
  return (
    <Route path={props.path} render={data => authInfos ?
      (<props.component {...data}></props.component>) :
      (<Redirect to={{ pathname: '/login' }}></Redirect>)}>
    </Route>
  )
}
class App extends Component {

  render() {
    return (
      <Router>
        <React.Suspense fallback={loading()}>
          <Switch>
            <Route exact path="/" name="Accueil" render={props => <Accueil {...props} />} ></Route>
            <Route exact path="/login" name="Login" render={props => <Login {...props} />} ></Route>
            <SecuredRoute exact name="Home" component={props => <TemplateMain {...props} />}></SecuredRoute>
          </Switch>
        </React.Suspense>
      </Router>
    );
  }
}

export default App;